import React from 'react';
import { css } from '@emotion/react';
import Colors from '../../../types/colors';
import TypographyView from '../../atoms/foundation/typography.view';
import MESSAGES from '../../../constants/messages';
import useDpi from '../../../hooks/useDpi';
import ButtonView from '../../atoms/inputs/button.view';
interface BarInfoViewProps {
  userName?: string;
  text?: string;
  buildDomToImage?: () => void;
}

const BarInfoView = ({ userName, text, buildDomToImage }: BarInfoViewProps) => {
  const { headerFontSize, subFontSize } = useDpi();
  const wrapper = css`
    display: flex;
    flex-direction: column;
    margin: 0 10px;
  `;
  const tabWrapper = css`
    display: flex;
    flex-direction: row;
    background-color: ${Colors['Grey_02_line']};
    border-radius: 13px;
    padding: 0 1rem;
    justify-content: end;
    font-size: 11px;
    color: ${Colors['Grey_03_regular']};
    height: 40px;
  `;
  const colorWrapper = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    font-size: ${subFontSize}px;
  `;

  const typography = css`
    margin: 15px 0;
    font-size: ${headerFontSize}px;
  `;

  return (
    <div css={wrapper}>
      {userName && (
        <TypographyView bold={true} cssStyles={typography}>
          {userName}
          {MESSAGES.INFORMATION.KEY_REPORT}
        </TypographyView>
      )}
      {buildDomToImage && (
        <div css={tabWrapper}>
          <div className="save_image_btn" css={colorWrapper}>
            <ButtonView handleClick={buildDomToImage} text={text ? text : '결과 다운로드'} variant="secondary" size={26} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BarInfoView;
